import { BehaviorSubject } from "rxjs";
import { TokenFlags } from "typescript";

import { handleResponse } from "../helpers/handle-response";
// Services
import { storeService } from "./storeService";

const currentUserSubject = new BehaviorSubject(
  JSON.parse(localStorage.getItem("currentUser"))
);

export const authenticationService = {
  login,
  logout,
  currentUser: currentUserSubject.asObservable(),
  get currentUserValue() {
    return currentUserSubject.value;
  },
  manualLogin,
  permisoStaff,
  signUp,
  resetUserPassword,
  resetUserPasswordRCF,
  validateIfUserexists,
  validateIfUserexistsRCF,
  validationUser, //validacion usuario por cedula
  loginReset,
};

function login(username, cardIdType, cardId, clinicId) {
  const body = JSON.stringify({
    username,
    cardIdType,
    cardId,
    clinicId,
  });

  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: body,
  };

  return fetch(
    process.env.REACT_APP_URL_HOST + "/cerotram/checkonhis",
    requestOptions
  )
    .then(handleResponse)
    .then((resp) => {
      // store user details and jwt token in local storage to keep user logged in between page refreshes
      if (!resp.error) {
        localStorage.setItem("currentUser", JSON.stringify(resp));
        currentUserSubject.next(resp);
      }
      return resp;
    });
}

function permisoStaff(email) {
  var formdata = new FormData();
  formdata.append("correo", email);

  var myHeaders = new Headers();
  myHeaders.append("Cookie", "ci_session=knv9mfrvdm1d5j81q1pmmg5q2j286igb");

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: formdata,
    redirect: "follow",
  };
  // andpoint url
  const url = "https://ecodigital.portubien.co/appric/permisoStaff";
  return fetch(url, requestOptions)
    .then((response) => response.json())
    .then((result) => result)
    .catch((error) => console.log("error", error));
}

function manualLogin(username, password) {
  const body = JSON.stringify({
    username,
    password,
    cardIdType: null,
  });

  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: body,
  };

  return fetch(
    process.env.REACT_APP_URL_HOST + "/cerotram/api/token/",
    requestOptions
  )
    .then(handleResponse)
    .then((tokens) => {
      // store user details and jwt token in local storage to keep user logged in between page refreshes
      /* localStorage.setItem('currentUser', JSON.stringify(resp));
      currentUserSubject.next(resp); */
      return tokens;
    });
}

function resetUserPassword(document, email, password) {
  const body = JSON.stringify({
    document: document,
    email: email,
    new_password: password,
  });

  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: body,
  };
  return fetch(
    process.env.REACT_APP_URL_HOST + "/cerotram/change/password/",
    requestOptions
  )
    .then(handleResponse)
    .then((resp) => {
      return resp;
    });
}

function resetUserPasswordRCF(username, password) {
  const body = JSON.stringify({
    email: username,
    new_password: password,
    password_confirmation: password,
  });

  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: body,
  };

  const url =
    process.env.REACT_APP_URL_HOST + "/reupload_image/usuarios/nueva_clave/";
  //const url = "https://dev-rcv.portubien.co/reupload_image/usuarios/nueva_clave/ ";
  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((resp) => {
      return resp;
    });
}

function validateIfUserexists(card_id, card_id_type) {
  const body = JSON.stringify({
    card_id: card_id,
    card_id_type: card_id_type,
  });

  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: body,
  };
  return fetch(
    process.env.REACT_APP_URL_HOST + "/cerotram/validate/username/",
    requestOptions
  )
    .then(handleResponse)
    .then((resp) => {
      return resp;
    });
}

function validateIfUserexistsRCF(username) {
  const body = JSON.stringify({
    email: username,
  });

  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: body,
  };

  const url =
    process.env.REACT_APP_URL_HOST +
    "/cerotram/validate/username/";

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((resp) => {
      return resp;
    });
}

function signUp({ firstName, lastName, dob, cardId, email, clinic, password }) {
  const dateOfBirth = dob.toDateString();
  const body = JSON.stringify({
    firstName,
    lastName,
    dateOfBirth,
    cardId,
    email,
    clinic,
    password,
  });

  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: body,
  };

  return fetch(
    process.env.REACT_APP_URL_HOST + "/cerotram/register/",
    requestOptions
  )
    .then((resp) => resp.json())
    .then((resp) => {
      // store user details and jwt token in local storage to keep user logged in between page refreshes
      /* localStorage.setItem('currentUser', JSON.stringify(resp));
      currentUserSubject.next(resp); */
      //console.log(resp);
      return resp;
    });
}
//// validacion si existe usuario segun numero de cedula
function validationUser(cardId, clinic) {
  const requestOptions = {
    method: "GET",
    redirect: "follow",
  };
  return fetch(
    process.env.REACT_APP_URL_HOST +
      `/cerotram/cedula_clinica/paciente/?Cedula=${cardId}&CodClinica=${clinic}`,
    requestOptions
  )
    .then((resp) => resp.json())
    .then((resp) => {
      return resp;
    });
}
///

function logout() {
  // remove user from local storage to log user out
  localStorage.removeItem("currentUser");
  const currentStore = storeService.loadFromLocalStorage();
  localStorage.setItem(
    "state",
    JSON.stringify({
      ...currentStore,
      lastContrat: "",
      patients: [],
      user: {},
      faceAuth: null,
      clinicsMaping: [],
      menuStaff: {},
      userStaff: {},
    })
  );
  currentUserSubject.next(null);
}

function loginReset(username, cardIdType, cardId) {
  const body = JSON.stringify({
    username,
    cardIdType,
    cardId,
  });

  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: body,
  };

  return fetch(
    process.env.REACT_APP_URL_HOST + "/cerotram/checkonhis",
    requestOptions
  )
    .then(handleResponse)
    .then((resp) => {
      // store user details and jwt token in local storage to keep user logged in between page refreshes
      if (!resp.error) {
        localStorage.setItem("currentUser", JSON.stringify(resp));
        currentUserSubject.next(resp);
      }
      return resp;
    });
}
